import { useEffect, useReducer } from 'react';
import { restaurantDisclaimers } from 'api/restaurantDisclaimers';
import { fetchReducer, FETCH_ACTION_TYPES } from 'reducers/fetchReducer';
import { useParams } from 'react-router';

const initialState = {
  loading: false,
  error: false,
  data: null,
};

const useRestaurantDisclaimers = (withoutFooter) => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  const { restaurantId } = useParams();
  useEffect(() => {
    let ignore = false;
    const fetch = async () => {
      if (restaurantId && !withoutFooter) {
        dispatch({ type: FETCH_ACTION_TYPES.loading, payload: { loading: true } });
        try {
          const response = await restaurantDisclaimers(restaurantId);
          if (!ignore && response) {
            dispatch({
              type: FETCH_ACTION_TYPES.setData,
              payload: { data: response },
            });
          }
        } catch (e) {
          if (!ignore) {
            dispatch({ type: FETCH_ACTION_TYPES.setError, payload: { error: e } });
          }
        }
      }
    };
    fetch();
    return () => {
      ignore = true;
    };
  }, [restaurantId, withoutFooter]);
  return state;
};

export default useRestaurantDisclaimers;
